module.exports = __webpack_public_path__ + "static/media/default-picture3.82261ae2.svg";